/**
 * PATH: apps/quote/src/components/builder/panels/ai-assistant/SimilarQuotesDisplay.tsx
 * PURPOSE: Display similar quotes results
 */

import { formatCurrency } from '@/lib/utils'
import type { SimilarQuotesResult } from '@/lib/quoteApi'

export default function SimilarQuotesDisplay({
  result,
  onOpenQuote,
}: {
  result: SimilarQuotesResult
  onOpenQuote?: (quoteId: string) => void
}) {
  return (
    <div className="space-y-2">
      <p className="text-sm text-slate-700 dark:text-slate-300">
        Found {result.similar_quotes?.length || 0} similar quotes
      </p>
      {result.similar_quotes?.slice(0, 5).map((quote) => (
        <div
          key={quote.id}
          className="p-2 bg-slate-50 dark:bg-slate-800 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 cursor-pointer"
          onClick={() => onOpenQuote?.(quote.id)}
        >
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-slate-900 dark:text-white truncate">
                {quote.quote_number}
              </p>
              <p className="text-xs text-slate-500 truncate">{quote.client_name}</p>
            </div>
            <div className="text-right shrink-0">
              <p className="text-sm font-semibold text-slate-900 dark:text-white">
                {formatCurrency(quote.total_excl_gst || 0)}
              </p>
              <p className="text-xs text-slate-400">
                {Math.round(quote.similarity * 100)}% match
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
